import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { TOUR_FEATURE_MAP } from '../constants/tourGuide';
import { useTour } from '../components/TourProvider';
import { useChatbotPromptStatus } from './useChatbotPromptStatus';

const API_BASE_URL = (process.env.REACT_APP_BASE_URL || "http://localhost:8000/api/v1") + "/chatbot";

export const useTourGuide = () => {
  const location = useLocation();
  const { showFeatureTour } = useTour();
  const { userData } = useSelector((store) => store.auth);
  const userId = userData?.id?.toString() || 'default';
  const { promptsDisabled, promptsDisabledLoaded } = useChatbotPromptStatus();
  const [visitedRoutes, setVisitedRoutes] = useState(null);

  useEffect(() => {
    if (!userId || userId === 'default') {
      setVisitedRoutes([]);
      return;
    }

    fetch(`${API_BASE_URL}/tour/${userId}/visited`)
      .then((res) => res.json())
      .then((data) => {
        setVisitedRoutes(data.visited_routes || []);
      })
      .catch(() => {
        setVisitedRoutes([]);
      });
  }, [userId]);

  useEffect(() => {
    if (!promptsDisabledLoaded || visitedRoutes === null) return;

    const currentPath = location.pathname;

    let featureName = null;
    let matchedPrefix = null;
    const sortedPrefixes = Object.keys(TOUR_FEATURE_MAP).sort((a, b) => b.length - a.length);
    for (const prefix of sortedPrefixes) {
      if (currentPath === prefix || currentPath.startsWith(prefix + '/')) {
        featureName = TOUR_FEATURE_MAP[prefix];
        matchedPrefix = prefix;
        break;
      }
    }

    if (!featureName || !matchedPrefix) return;
    if (promptsDisabled) return;
    if (visitedRoutes.includes(matchedPrefix)) return;

    setTimeout(() => {
      showFeatureTour(featureName);

      fetch(`${API_BASE_URL}/tour/${userId}/visited`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ route: matchedPrefix }),
      }).catch((err) => {
        console.error('[TOUR] Failed to mark route visited:', err);
      });

      setVisitedRoutes((prev) => [...prev, matchedPrefix]);
    }, 1500);
  }, [location.pathname, showFeatureTour, userId, promptsDisabled, promptsDisabledLoaded, visitedRoutes]);
};
